import type { TenantConfig } from '@/types/TenantConfig'

export const factoryobscura: TenantConfig = {
  logo: 'assets/factoryobscura/static/logo.png',
  themeOptions: {
    dialog: {
      headerBackground: '#000000',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
    },
  },
  teaserImageSize: {
    height: 208,
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/factoryobscura/static/completed-image.jpeg',
        mobile: 'assets/factoryobscura/static/completed-image-mobile.jpeg',
      },
      completedContentOffset: {
        desktop: '-250px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap',
    },
  },
}
